import api from './APIService';

class RegistrationService {

	getAll() {
		return api.fetch({ method: 'get', path: '/participant/registrations' });
	}
	getPromoter(id){
		return api.fetch({ method: 'get', path: '/participant/getPromoter/'+id });
	}
	getPromoterbyId(id){
		return api.fetch({ method: 'get', path: '/participant/promoter/'+id });
	}
	getPromoterbyUserId(id){
		return api.fetch({ method: 'get', path: '/participant/getPromoterByUserId/'+id });
	}
	getRegistrationById(id){
		return api.fetch({ method: 'get', path: '/participant/registrations/'+id });
	}
	getPromoterList(){
		return api.fetch({ method: 'get', path: '/participant/register/event/promoters' });
	}
	getPromoterListDays($days){
		return api.fetch({ method: 'get', path: '/participant/register/event/promoters/days/'+$days });
	}
	getEventsByPromoter(data){
		return api.fetch({ method: 'post', path: '/participant/register/event/promoters/events/', data });
	}
	getClasses($eventId){
		return api.fetch({ method: 'get', path: '/users/current/promoter/race/getEventClasses/'+$eventId });
	}
	getBrands($eventId, $userId){
		return api.fetch({ method: 'get', path: '/participant/register/event/brands/'+$eventId+'/'+$userId });
	}
	validationUsers(data) {
		return api.fetch({ method: 'post', path: '/participant/register/event/validationUsers', data });
	}
	verifyStatus(data) {
		return api.fetch({ method: 'post', path: '/participant/register/event/verifyStatus', data});
	}
	checkEventMembership(data) {
		return api.fetch({ method: 'post', path: '/participant/register/event/checkEventMembership', data });
	}
	hasWaiversToSignForEvent(data) {
		return api.fetch({ method: 'post', path: '/participant/register/event/hasWaiversToSignForEvent', data });
	}
	getEventRegistrationClasses(data) {
		return api.fetch({ method: 'post', path: '/participant/register/event/getEventRegistrationClasses', data });
	}
	getEventSelfOrg(data) {
		return api.fetch({ method: 'post', path: '/participant/register/event/getEventSelfOrg', data });
	}
	getCompleteRegistration(data) {
		return api.fetch({ method: 'post', path: `/participant/register/event/getRegistrant`, data});
	}
	createEventRegistration(data) {
		return api.fetch({ method: 'post', path: `/participant/register/event/createEventRegistration`, data });
	}
	generateNumbers($eventId, $userId) {
		return api.fetch({ method: 'get', path: `/participant/register/event/numbers/${$eventId}/${$userId}`});
	}
	getCanceledRegistration(data) {
		return api.fetch({ method: 'post', path: `/participant/register/event/cancelRegistration`, data });
	}
	createEventRegistrationLegacy(data) {
		return api.fetch({method: 'post', path: `/participant/register/event/createEventRegistrationLegacy`, data });
	}
	getVerify($eventId) {
		return api.fetch({ method: 'get', path: `/participant/register/event/getVerify/validate/${$eventId}` });
	}
	createOrganizationRegistrant(data) {
		return api.fetch({ method: 'post', path: `/participant/register/organization/createRegistration`, data });
	}
	verifyOrganizationStatus(data) {
		return api.fetch({ method: 'post', path: `/participant/register/organization/verifyStatus`, data });
	}
	validationOrganizationUsers(data) {
		return api.fetch({ method: 'post', path: `/participant/register/organization/validationUsers`, data });
	}
	checkAvailability($eventId, data) {
		return api.fetch({ method: 'post', path: `/participant/register/event/promoters/checkAvailability/${$eventId}`, data });
	}
	verifyRegistrationDate($eventId) {
		return api.fetch({ method: 'get', path: `/participant/register/event/promoters/verifyRegistrationDate/${$eventId}` });
	}
	verifyEventWaiver(data) {
		return api.fetch({ method: 'post', path: '/participant/register/event/verifyEventWaiver', data });
	}
	verifyValidateSpectators(data) {
		return api.fetch({ method: 'post', path: '/participant/register/event/verifyValidateSpectators', data});
	}
	verifyValidateReserved(data) {
		return api.fetch({ method: 'post', path: '/participant/register/event/verifyValidateReserved', data });
	}
	verifyValidateReservedAll(data) {
		return api.fetch({ method: 'post', path: '/participant/register/event/verifyValidateReservedAll', data });
	}
	getEvent($eventId,$userId) {
		return api.fetch({ method: 'get', path: `/participant/register/event/${$eventId}/${$userId}` });
	}
	getPermissionEvent($eventId,$usersId) {
		return api.fetch({ method: 'get', path: `/participant/register/event/hasPermissionEvent/${$eventId}/${$usersId}` });
	}
}

export default new RegistrationService();
